<template>
  <!-- Sender, Receiver, details, items -->
  <div class="consignment-popover">
    <ConsignmentPeek
      :consignment="consignment"
      :show-cards="['information', 'items', 'tracking']"
    />
  </div>
</template>
<script>
import ConsignmentPeek from '../Application/Freight/ConsignmentPeek'

export default {
  name: 'ConsignmentPopover',
  components: {
    ConsignmentPeek
  },
  props: {
    consignment: {
      type: Object,
      required: true
    }
  },
  methods: {
    getStatusType (status) {
      const statusLower = status.toLowerCase()
      if (statusLower.includes('active') || statusLower.includes('complete')) {
        return 'success'
      } else if (statusLower.includes('pending') || statusLower.includes('progress')) {
        return 'warning'
      } else if (statusLower.includes('inactive') || statusLower.includes('cancelled')) {
        return 'info'
      }
      return ''
    }
  }
}
</script>

<style scoped>
.consignment-popover {
  width: max-content;
  min-width: 360px;
  max-width: calc(100vw - 64px);
  max-height: calc(100vh - 96px);
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
}

.popover-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #f0f0f0;
}

.popover-row:last-child {
  border-bottom: none;
}

.popover-label {
  font-weight: 600;
  color: #606266;
  margin-right: 12px;
  min-width: 120px;
}

.popover-value {
  color: #303133;
  flex: 1;
  text-align: right;
}
</style>
